var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "recharge-feedback-help-dialog" },
    [
      !_vm.isExpanded && _vm.dialogDismissed
        ? _c(
            "div",
            {
              staticClass: "recharge-feedback-help-dialog-bottom",
              on: { click: _vm.openExpanded }
            },
            [
              _c("div", { staticClass: "left" }, [
                _c("img", {
                  staticClass: "rechargeIcon",
                  attrs: { src: _vm.feedbackIcon }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("m.feedback_and_help")))
                ])
              ]),
              _vm._v(" "),
              _c("img", {
                staticClass: "closeIcon",
                attrs: { src: _vm.closeIcon },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.dismissSecondPaymentDialog.apply(null, arguments)
                  }
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "modal-slide" } }, [
        _vm.isExpanded
          ? _c(
              "div",
              {
                staticClass: "rfhd-modal-overlay",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    return _vm.closeExpanded(false)
                  }
                }
              },
              [
                _c("div", { staticClass: "rfhd-modal" }, [
                  _c("div", { staticClass: "rfhd-modal-header" }, [
                    _c("div", { staticClass: "rfhd-modal-title-wrap" }, [
                      _c("div", { staticClass: "rfhd-modal-title" }, [
                        _vm._v(_vm._s(_vm.$t("m.feedback_and_help")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "rfhd-modal-close",
                      attrs: { src: _vm.modalCloseIcon },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.closeExpanded(false)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "rfhd-modal-body" }, [
                    _c("div", { staticClass: "rfhd-intro" }, [
                      _c("img", {
                        staticClass: "rfhd-intro-icon",
                        attrs: {
                          src: require("@/assets/img/logo.png"),
                          alt: "icon"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "rfhd-intro-text" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t("m.try_recharge_methods", {
                                feedback: _vm.$t("m.feedback")
                              })
                            ) +
                            "\n              "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "rfhd-recommend-title" }, [
                      _vm._v(_vm._s(_vm.$t("m.recommended_recharge_methods")))
                    ]),
                    _vm._v(" "),
                    _vm.paymentMethodsLocal && _vm.paymentMethodsLocal.length
                      ? _c(
                          "div",
                          { staticClass: "payment-scroll-container" },
                          [
                            _c(
                              "van-collapse",
                              {
                                staticClass: "payStyleCon",
                                attrs: {
                                  value: _vm.activePayIndex,
                                  accordion: ""
                                },
                                on: { input: _vm.setActivePayIndex }
                              },
                              [
                                _vm.traderOption
                                  ? _c(
                                      "van-collapse-item",
                                      {
                                        key: "pay-trader",
                                        attrs: { name: "trader" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "title",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "fc-flex fc-flex-vcenter",
                                                      on: {
                                                        click:
                                                          _vm.onTraderTitleClick
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "payStyleIcon"
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                (_vm
                                                                  .traderOption
                                                                  .rechargePayType &&
                                                                  _vm
                                                                    .traderOption
                                                                    .rechargePayType
                                                                    .payTypeImg) ||
                                                                "@/assets/img/logo.png",
                                                              alt:
                                                                (_vm
                                                                  .traderOption
                                                                  .rechargePayType &&
                                                                  _vm
                                                                    .traderOption
                                                                    .rechargePayType
                                                                    .payTypeShowName) ||
                                                                "币商"
                                                            }
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "fc-flex1 fc-text-bigabit"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              (_vm.traderOption
                                                                .rechargePayType &&
                                                                _vm.traderOption
                                                                  .rechargePayType
                                                                  .payTypeShowName) ||
                                                                _vm.traderOption
                                                                  .name ||
                                                                "币商"
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          false,
                                          4127720930
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        _vm.traderOption.rechargePayType &&
                                        _vm.traderOption.rechargePayType
                                          .payTypeShowName &&
                                        _vm.traderOption.rechargePayType.payTypeShowName.toLowerCase() ==
                                          "razer gold pin"
                                          ? _c(
                                              "div",
                                              { staticClass: "payTiptxt" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("m.recharge_tip")
                                                    )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.sellerList.length > 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "sellers-content"
                                              },
                                              _vm._l(_vm.sellerList, function(
                                                item,
                                                index
                                              ) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "seller-item"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "seller-item-head"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "fc-relative"
                                                          },
                                                          [
                                                            _c("img", {
                                                              staticClass:
                                                                "seller-photo",
                                                              attrs: {
                                                                src: item.img
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("img", {
                                                              staticClass:
                                                                "seller-flag",
                                                              attrs: {
                                                                src: item.logo
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "seller-info"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "seller-title-id"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "seller-title fc-elip-2"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.nickname
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "seller-ids"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "seller-id"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "ID:" +
                                                                            _vm._s(
                                                                              item.userId
                                                                            )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "copy-btn",
                                                                      attrs: {
                                                                        src: require("@/assets/img/copy.png")
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.copySellerId(
                                                                            $event,
                                                                            item.userId
                                                                          )
                                                                        }
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "seller-balance"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "balance-title fc-elip-1"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "m.buy_balance"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "balance-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/img/diamond.png")
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "balance-num"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.diamond
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "seller-paytypes"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "paytypes-list"
                                                          },
                                                          _vm._l(
                                                            item.payTypes,
                                                            function(pay, i) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "paytype-box"
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src:
                                                                        pay.payTypeImg
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }),
                                              0
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.sellerList.length < 1 &&
                                        _vm.userInfo.userId
                                          ? _c(
                                              "div",
                                              { staticClass: "sellers-nodata" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("@/assets/img/nodata.png"),
                                                    alt: ""
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.sellerList.length < 1 &&
                                        !_vm.userInfo.userId
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "sellers-no-login"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "no-login-content"
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("@/assets/img/noLogin.png"),
                                                        alt: ""
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass: "login-tip"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "m.login_after_recharge"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "fc-btn-line-login",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.$router.push(
                                                          "/login"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("m.login"))
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.showSellersList
                                          ? _c("van-list", {
                                              staticClass:
                                                "sellers-list-hidden",
                                              attrs: {
                                                "loading-text": "加载中...",
                                                finished: _vm.sellersFinished,
                                                "finished-text": ""
                                              },
                                              on: { load: _vm.getSellerList },
                                              model: {
                                                value: _vm.sellersLoading,
                                                callback: function($$v) {
                                                  _vm.sellersLoading = $$v
                                                },
                                                expression: "sellersLoading"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.otherPaymentMethods, function(
                                  item,
                                  index
                                ) {
                                  return item.rechargePayType && !item.isTrader
                                    ? _c(
                                        "van-collapse-item",
                                        {
                                          key: "pay" + index,
                                          attrs: { name: index },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "title",
                                                fn: function() {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "fc-flex fc-flex-vcenter"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "payStyleIcon"
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src:
                                                                  item
                                                                    .rechargePayType
                                                                    .payTypeImg ||
                                                                  "@/assets/img/logo.png",
                                                                alt:
                                                                  item
                                                                    .rechargePayType
                                                                    .payTypeShowName ||
                                                                  "Payment"
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "fc-flex1 fc-text-bigabit"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item
                                                                  .rechargePayType
                                                                  .payTypeShowName ||
                                                                  item.payTypeName ||
                                                                  "Payment Method"
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          item.rechargePayType
                                            .payTypeShowName &&
                                          item.rechargePayType.payTypeShowName.toLowerCase() ==
                                            "razer gold pin"
                                            ? _c(
                                                "div",
                                                { staticClass: "payTiptxt" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("m.recharge_tip")
                                                      )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm._l(
                                            item.rechargeNormList || [],
                                            function(son, sonIndex) {
                                              return son
                                                ? _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "paymoney" + sonIndex,
                                                      staticClass: "buyInfoItem"
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "diamond_icon",
                                                        attrs: {
                                                          src: require("@/assets/img/diamond.png"),
                                                          alt: "diamond"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fc-flex fc-flex-vcenter fc-flex1"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "buyNum"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  son.newNumber ||
                                                                    son.number ||
                                                                    0
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          (son.awardNumber ||
                                                            0) > 0
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "morereward_txt"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "+" +
                                                                      _vm._s(
                                                                        son.awardNumber ||
                                                                          0
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          son.img &&
                                                          son.isActivity
                                                            ? _c("img", {
                                                                staticClass:
                                                                  "morereward_img",
                                                                attrs: {
                                                                  src: son.img,
                                                                  alt:
                                                                    "activity"
                                                                }
                                                              })
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fc-btn-line-main payBtn",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.handleRechargeClick(
                                                                item,
                                                                son
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.calLocalMoney(
                                                                  son
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      : _c("div", { staticClass: "nodataImg" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/nodata.png"),
                              alt: "no data"
                            }
                          })
                        ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "rfhd-modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "rfhd-feedback-btn",
                        on: { click: _vm.onFeedback }
                      },
                      [_vm._v(_vm._s(_vm.$t("m.feedback")))]
                    )
                  ])
                ])
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-748fa005", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-748fa005","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RechargeFeedbackHelpDialog.vue
// module id = null
// module chunks = 